import { Link, styled } from '@mui/material';

export const ErrorBoundaryContainer = styled('main', { name: 'ErrorBoundaryContainer' })(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3.5rem',
    minHeight: '100vh',
    padding: '2rem',
    textAlign: 'center',
    backgroundColor: theme.ciPalette.background.powderGray,
}));

export const ErrorBoundaryMessage = styled('div', { name: 'ErrorBoundaryMessage' })({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1.5rem',
});

export const ErrorBoundaryHeading = styled('h1', { name: 'ErrorBoundaryHeading' })(({ theme }) => ({
    margin: 0,
    fontSize: '1.75rem',
    lineHeight: 1,
    fontWeight: 500,
    color: theme.ciPalette.brand.blue,
}));

export const ErrorBoundaryBody = styled('p', { name: 'ErrorBoundaryBody' })(({ theme }) => ({
    margin: 0,
    maxWidth: '33rem',
    fontSize: '1.125rem',
    lineHeight: 1.444,
    color: theme.ciPalette.text.lightBlack,
}));

export const ErrorBoundaryFooter = styled('div', { name: 'ErrorBoundaryFooter' })(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    color: theme.ciPalette.lightGrey.text,
}));

export const ErrorBoundaryDivider = styled('span', { name: 'ErrorBoundaryDivider' })(({ theme }) => ({
    inlineSize: '1px',
    blockSize: '1.375rem',
    backgroundColor: theme.ciPalette.lightGrey.border,
}));

export const ErrorBoundarySupportLink = styled(Link, { name: 'ErrorBoundarySupportLink' })(({ theme }) => ({
    fontSize: '0.875rem',
    lineHeight: 1.571,
    color: theme.ciPalette.text.link,
}));
